import * as React from 'react';
import { ProfileDropdown } from '@ghq-abi/design-system';
import { ProfileDropdownItemProps } from '@ghq-abi/design-system/dist/components/ProfileDropdown/ProfileDropdownItem';

import { useUserDropdown } from './hooks';

export function UserDropdown() {
    const { items, profileInfo } = useUserDropdown();

    return (
        <ProfileDropdown
            items={items.filter(Boolean) as ProfileDropdownItemProps[]}
            profileInfo={profileInfo}
        />
    );
}
